// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3P0wO","paramInput":"JobSimulator_paramInput__1UBvW","input":"JobSimulator_input__3K0NL"};